const ScrollToTop = ({isActive = false}) => {
    return (
    <button  onClick={() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }}
      aria-label={'Скролл до верха'}
      
      className={`
  ${isActive 
    ? 'opacity-100 bottom-[11.4rem] pointer-events-auto' 
    : 'opacity-0 bottom-[5rem] pointer-events-none'}
  duration-300 transition-[opacity,bottom,color,background-color]
  flex fixed z-30 right-[2rem] md:right-[2.4rem] lg:right-[3.6rem] xl:right-[4.8rem]
  hover:text-white cursor-pointer hover:bg-dusty-blue
  h-[3.2rem] w-[3.2rem] items-center justify-center
  bg-dusty-green text-btn
`}
    >
     <svg className='-rotate-90' width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 7H12M12 7L6 1M12 7L6 13" stroke="CurrentColor"/>
                        </svg>
    </button>
    );
};

export default ScrollToTop;